import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";
import PropTypes from "prop-types";

import { HyphenIcon } from "@transfr-inc/dashboard-components";

import { Tooltip } from "@features/ui/tooltip";
import { percentageFormat } from "@lib/text.helpers";

import "./percentage-info.scss";

export const PercentageInfo = ({
  value,
  description,
  tooltip,
  children,
  className,
}) => {
  const infoElement = (
    <span className={clsx(tooltip && "has-tooltip")}>
      {description}
      {tooltip && (
        <FontAwesomeIcon icon={["fa-regular", "circle-info"]} title="info" />
      )}
    </span>
  );

  return (
    <div className={clsx(className, "percentage-info")}>
      <div className="percentage-info-value">
        {typeof value === "number" ? percentageFormat(value) : <HyphenIcon />}
      </div>
      <Tooltip
        className="percentage-info-tooltip"
        disabled={!tooltip}
        content={tooltip}
      >
        <div className="percentage-info-description">
          {children ?? infoElement}
        </div>
      </Tooltip>
    </div>
  );
};

PercentageInfo.propTypes = {
  children: PropTypes.object,
  className: PropTypes.string,
  description: PropTypes.node,
  tooltip: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(["-"])]),
};
